import Base from './Base.vue'
import Overview from './Overview.vue'

export default {
    Base,
    Overview
}



// WEBPACK FOOTER //
// ./src/views/customer/downloads/index.js